import * as actions from './actionConstants';

export const getTodaysWeather = (latitude, longitude, timezone) => ({
  type: actions.GET_TODAYS_WEATHER,
  latitude, 
  longitude, 
  timezone
});

export const getTodaysWeatherSuccess = (todaysWeather) => ({
  type: actions.GET_TODAYS_WEATHER_SUCCESS,
  todaysWeather
});

export const getTodaysWeatherError = error => ({
  type: actions.GET_TODAYS_WEATHER_ERROR,
  error
});



// WEBPACK FOOTER //
// ./src/actions/weatherActions.js